import Widget from '../Widget';

/**
 * @description Hide "Read More" button when it appears during scrolling and fixes the label in case the text is too long, so it is all displayed
 */
export default class HideReadMore extends Widget {
    init() {
        window.addEventListener('scroll', this.checkAndRemoveButton);
    }

    checkAndRemoveButton() {
        this.readMoreButton = document.querySelector('[data-widget="hideReadMore"] .l-search__viewmore-button');
        this.label = document.querySelector('[data-widget="hideReadMore"] label');

        if (this.readMoreButton) {
            this.readMoreButton.remove();
            window.removeEventListener('scroll', this.checkAndRemoveButton);
        }

        if (this.label) {
            this.label.classList.add('fullLabel');
            window.removeEventListener('scroll', this.checkAndRemoveButton);
        }
    }
}
